// extracted by mini-css-extract-plugin
export default {"settings":"ImportExportData_settings__Dogmt"};